import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import LaundryModal from '../../common/LaundryModal'

import * as Strings from './strings'
import * as configActions from '../../actions/Config'
import * as laundriesActions from '../../actions/Laundries'

class EditLaundryModal extends Component {
  state = {
    nameInput: '',
    outOfOrder: false,
    errorName: '',
    errorMessage: ''
  }

  componentWillReceiveProps(nextProps) {
    const { config, laundries, data } = this.props
    const laundryType =
      data.laundrySystem.laundryRule.laundryType

    if (
      nextProps.config.editLaundryModal.show &&
      !config.editLaundryModal.show
    ) {
      this.setState({
        nameInput: nextProps.laundries.selected.name,
        outOfOrder: !nextProps.laundries.selected.functioning,
        errorName: '',
        errorMessage: ''
      })
    }

    if (
      !nextProps.laundries.isUpdating &&
      nextProps.laundries.errorUpdating === null &&
      laundries.isUpdating
    ) {
      this.props.hideEditLaundryModal()
      this.props.showSnackbar(Strings.default.LAUNDRY_UPDATED[laundryType])
    } else if (
      !nextProps.laundries.isUpdating &&
      nextProps.laundries.errorUpdating !== null &&
      laundries.isUpdating
    ) {
      this.setState({ errorMessage: Strings.default.INTERNAL_ERROR })
    }
  }

  updateLaundry() {
    const { data, user, laundries } = this.props
    const { nameInput, outOfOrder } = this.state

    this.setState({ errorMessage: '' })

    if (nameInput === '') {
      this.setState({ errorName: Strings.default.MANDATORY_FIELD })
    }

    if (nameInput !== '') {
      const postData = {
        name: nameInput,
        functioning: !outOfOrder
      }

      this.props.tryUpdateLaundry(
        user.token,
        data.community.id,
        laundries.selected.id,
        postData
      )
    }
  }

  render() {
    const { config, laundries, data } = this.props
    const { nameInput, errorName, errorMessage, outOfOrder } = this.state
    const laundryType =
      data.laundrySystem.laundryRule.laundryType

    return (
      <LaundryModal
        show={config.editLaundryModal.show}
        hide={() => this.props.hideEditLaundryModal()}
        nameInput={nameInput}
        onChangeNameInput={text =>
          this.setState({
            nameInput: text,
            errorName: '',
            errorMessage: ''
          })
        }
        outOfOrder={outOfOrder}
        onChangeOutOfOrder={checked => this.setState({ outOfOrder: checked })}
        errorName={errorName}
        header={Strings.default.EDIT_LAUNDRY[laundryType]}
        information={Strings.default.EDIT_LAUNDRY_INFORMATION[laundryType]}
        onDone={() => this.updateLaundry()}
        loading={laundries.isUpdating}
        errorMessage={errorMessage}
      />
    )
  }
}

function mapStateToProps({ config, data, user, laundries }) {
  return { config, data, user, laundries }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...configActions, ...laundriesActions }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(EditLaundryModal)



// WEBPACK FOOTER //
// ./src/components/containers/EditLaundryModal/index.js